<script>import { ICON_STROKE_MAP } from "./";
export let size = 24;
</script>
<svg width={size} height={size} stroke-width={ICON_STROKE_MAP[size]} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...$$props}><path d="M17.7 6.3L6.30005 17.7M17.7 17.7L6.30005 6.3" stroke="currentColor"/></svg>